import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.string.trim-end.js";
import t from "react";

function e() {
  return (e = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
    }

    return t;
  }).apply(this, arguments);
}

var n = /[\'\"]/;

var r = ["children", "options"],
    o = ["allowFullScreen", "allowTransparency", "autoComplete", "autoFocus", "autoPlay", "cellPadding", "cellSpacing", "charSet", "className", "classId", "colSpan", "contentEditable", "contextMenu", "crossOrigin", "encType", "formAction", "formEncType", "formMethod", "formNoValidate", "formTarget", "frameBorder", "hrefLang", "inputMode", "keyParams", "keyType", "marginHeight", "marginWidth", "maxLength", "mediaGroup", "minLength", "noValidate", "radioGroup", "readOnly", "rowSpan", "spellCheck", "srcDoc", "srcLang", "srcSet", "tabIndex", "useMap"].reduce(function (t, e) {
  return t[e.toLowerCase()] = e, t;
}, {
  for: "htmlFor"
}),
    c = {
  amp: "&",
  apos: "'",
  gt: ">",
  lt: "<",
  nbsp: " ",
  quot: "“"
},
    a = ["style", "script"],
    u = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi,
    i = /mailto:/i,
    l = /\n{2,}$/,
    s = /^( *>[^\n]+(\n[^\n]+)*\n*)+\n{2,}/,
    _2 = /^ *> ?/gm,
    f = /^ {2,}\n/,
    d = /^(?:( *[-*_]) *){3,}(?:\n *)+\n/,
    p = /^\s*(`{3,}|~{3,}) *(\S+)? *\n([\s\S]+?)\s*\1 *(?:\n *)+\n?/,
    g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/,
    m = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,
    y = /^(?:\n *)*\n/,
    h = /\r\n?/g,
    k = /^\[\^([^\]]+)](:.*)\n/,
    x = /^\[\^([^\]]+)]/,
    v = /\f/g,
    b = /^\s*?\[(x|\s)\]/,
    S = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/,
    $ = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/,
    w = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?([^>]*)\/{0}>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1)[\s\S])*?)<\/\1>\n*/i,
    z = /&([a-z]+);/g,
    E = /^<!--[\s\S]*?(?:-->)/,
    A = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/,
    R = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i,
    I = /^\{.*\}$/,
    M = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,
    O = /^<([^ >]+@[^ >]+)>/,
    B = /^<([^ >]+:\/[^ >]+)>/,
    L = / *\n+$/,
    T = /(?:^|\n)( *)$/,
    j = /-([a-z])?/gi,
    C = /^(.*\|?.*)\n *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*)\n?/,
    D = /^\[([^\]]*)\]:\s*(\S+)\s*("([^"]*)")?/,
    N = /^!\[([^\]]*)\] ?\[([^\]]*)\]/,
    Z = /^\[([^\]]*)\] ?\[([^\]]*)\]/,
    F = /(\[|\])/g,
    P = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/,
    G = /\t/g,
    H = /^ *\| */,
    q = /(^ *\||\| *$)/g,
    U = / *$/,
    V = /^ *:-+: *$/,
    W = /^ *:-+ *$/,
    Q = /^ *-+: *$/,
    X = /^([*_])\1((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1\1(?!\1)/,
    J = /^([*_])((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1(?!\1|\w)/,
    K = /^~~((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)~~/,
    Y = /^\\([^0-9A-Za-z\s])/,
    tt = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i,
    et = /^\n+/,
    nt = /^([ \t]*)/,
    rt = /\\([^0-9A-Z\s])/gi,
    ot = new RegExp("^( *)((?:[*+-]|\\d+\\.)) +"),
    ct = new RegExp("^( *)((?:[*+-]|\\d+\\.)) +[^\\n]*(?:\\n(?!\\1(?:[*+-]|\\d+\\.) )[^\\n]*)*(\\n|$)", "gm"),
    at = new RegExp("^( *)((?:[*+-]|\\d+\\.)) [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1(?:[*+-]|\\d+\\.) (?!(?:[*+-]|\\d+\\.) ))\\n*|\\s*\\n*$)"),
    ut = "(?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*",
    it = new RegExp("^\\[(" + ut + ")\\]\\(\\s*<?((?:[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"),
    lt = new RegExp("^!\\[(" + ut + ")\\]\\(\\s*<?((?:[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"),
    st = [s, g, p, S, $, E, ct, at, C],
    _t = [].concat(st, [/^[^\n]+(?:  \n|\n{2,})/, w, R]);

function ft(t) {
  return t.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}

function dt(t) {
  return Q.test(t) ? "right" : V.test(t) ? "center" : W.test(t) ? "left" : null;
}

function pt(t, e, n) {
  var r = n.t;
  n.t = !0;
  var o = e(t.trim(), n);
  n.t = r;
  var c = [[]];
  return o.forEach(function (t, e) {
    "tableSeparator" === t.type ? 0 !== e && e !== o.length - 1 && c.push([]) : ("text" !== t.type || null != o[e + 1] && "tableSeparator" !== o[e + 1].type || (t.content = t.content.replace(U, "")), c[c.length - 1].push(t));
  }), c;
}

function gt(t, e, n) {
  n.o = !0;

  var r = pt(t[1], e, n),
      o = t[2].replace(q, "").split("|").map(dt),
      c = function (t, e, n) {
    return t.trim().split("\n").map(function (t) {
      return pt(t, e, n);
    });
  }(t[3], e, n);

  return n.o = !1, {
    align: o,
    cells: c,
    header: r,
    type: "table"
  };
}

function mt(t, e) {
  return null == t.align[e] ? {} : {
    textAlign: t.align[e]
  };
}

function yt(t) {
  return function (e, n) {
    return n.o ? t.exec(e) : null;
  };
}

function ht(t) {
  return function (e, n) {
    return n.o || n.u ? t.exec(e) : null;
  };
}

function kt(t) {
  return function (e, n) {
    return n.o || n.u ? null : t.exec(e);
  };
}

function xt(t) {
  return function (e) {
    return t.exec(e);
  };
}

function vt(t, e, n) {
  if (e.o || e.u) return null;
  if (n && !n.endsWith("\n")) return null;
  var r = "";
  t.split("\n").every(function (t) {
    return !st.some(function (e) {
      return e.test(t);
    }) && (r += t + "\n", t.trim());
  });
  var o = r.trimEnd();
  return "" == o ? null : [r, o];
}

function bt(t) {
  try {
    if (decodeURIComponent(t).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data):/i)) return null;
  } catch (t) {
    return null;
  }

  return t;
}

function St(t) {
  return t.replace(rt, "$1");
}

function $t(t, e, n) {
  var r = n.o || !1,
      o = n.u || !1;
  n.o = !0, n.u = !0;
  var c = t(e, n);
  return n.o = r, n.u = o, c;
}

function wt(t, e, n) {
  var r = n.o || !1,
      o = n.u || !1;
  n.o = !1, n.u = !0;
  var c = t(e, n);
  return n.o = r, n.u = o, c;
}

function zt(t, e, n) {
  return n.o = !1, t(e + "\n\n", n);
}

var Et = function Et(t, e, n) {
  return {
    content: $t(e, t[1], n)
  };
};

function At() {
  return {};
}

function Rt() {
  return null;
}

function It() {
  for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
    t[_key] = arguments[_key];
  }

  return t.filter(Boolean).join(" ");
}

function Mt(t, e, n) {
  var r = t;
  var o = e.split(".");

  for (; o.length && (r = r[o[0]], void 0 !== r);) {
    o.shift();
  }

  return r || n;
}

var Ot;

function Bt(r) {
  var q = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  q.overrides = q.overrides || {}, q.slugify = q.slugify || ft, q.namedCodesToUnicode = q.namedCodesToUnicode ? e({}, c, q.namedCodesToUnicode) : c;
  var U = q.createElement || t.createElement;

  function V(t, n) {
    var o = Mt(q.overrides, "".concat(t, ".props"), {});

    for (var _len2 = arguments.length, r = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      r[_key2 - 2] = arguments[_key2];
    }

    return U.apply(void 0, [function (t, e) {
      var n = Mt(e, t);
      return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : Mt(e, "".concat(t, ".component"), t) : t;
    }(t, q.overrides), e({}, n, o, {
      className: It(null == n ? void 0 : n.className, o.className) || void 0
    })].concat(r));
  }

  function W(e) {
    var n = !1;
    q.forceInline ? n = !0 : q.forceBlock || (n = !1 === P.test(e));
    var r = pt(dt(n ? e : "".concat(e.trimEnd().replace(et, ""), "\n\n"), {
      o: n
    }));

    for (; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();) {
      r.pop();
    }

    if (null === q.wrapper) return r;
    var o = q.wrapper || (n ? "span" : "div");
    var c;
    if (r.length > 1 || q.forceWrapper) c = r;else {
      if (1 === r.length) return c = r[0], "string" == typeof c ? V("span", {
        key: "outer"
      }, c) : c;
      c = null;
    }
    return t.createElement(o, {
      key: "outer"
    }, c);
  }

  function Q(e) {
    var r = e.match(u);
    return r ? r.reduce(function (e, r, c) {
      var a = r.indexOf("=");

      if (-1 !== a) {
        var _u = function (t) {
          return -1 !== t.indexOf("-") && null === t.match(A) && (t = t.replace(j, function (t, e) {
            return e.toUpperCase();
          })), t;
        }(r.slice(0, a)).trim(),
            _i = function (t) {
          return t ? (n.test(t.charAt(0)) && (t = t.substr(1)), n.test(t.charAt(t.length - 1)) && (t = t.substr(0, t.length - 1)), t) : "";
        }(r.slice(a + 1).trim()),
            _l = o[_u] || _u,
            _s = e[_l] = function (t, e) {
          return "style" === t ? e.split(/;\s?/).reduce(function (t, e) {
            var n = e.slice(0, e.indexOf(":"));
            return t[n.replace(/(-[a-z])/g, function (t) {
              return t[1].toUpperCase();
            })] = e.slice(n.length + 1).trim(), t;
          }, {}) : "href" === t ? bt(e) : (e.match(I) && (e = e.slice(1, e.length - 1)), "true" === e || "false" !== e && e);
        }(_u, _i);

        "string" == typeof _s && (w.test(_s) || R.test(_s)) && (e[_l] = t.cloneElement(W(_s.trim()), {
          key: c
        }));
      } else "style" !== r && (e[o[r] || r] = !0);

      return e;
    }, {}) : void 0;
  }

  var rt = [],
      ut = {},
      st = {
    blockQuote: {
      i: kt(s),
      l: Ot.HIGH,
      _: function _(t, e, n) {
        return {
          content: e(t[0].replace(_2, ""), n)
        };
      },
      p: function p(t, e, n) {
        return V("blockquote", {
          key: n.g
        }, e(t.content, n));
      }
    },
    breakLine: {
      i: xt(f),
      l: Ot.HIGH,
      _: At,
      p: function p(t, e, n) {
        return V("br", {
          key: n.g
        });
      }
    },
    breakThematic: {
      i: kt(d),
      l: Ot.HIGH,
      _: At,
      p: function p(t, e, n) {
        return V("hr", {
          key: n.g
        });
      }
    },
    codeBlock: {
      i: kt(g),
      l: Ot.MAX,
      _: function _(t) {
        return {
          content: t[0].replace(/^ {4}/gm, "").replace(/\n+$/, ""),
          lang: void 0
        };
      },
      p: function p(t, e, n) {
        return V("pre", {
          key: n.g
        }, V("code", {
          className: t.lang ? "lang-".concat(t.lang) : ""
        }, t.content));
      }
    },
    codeFenced: {
      i: kt(p),
      l: Ot.MAX,
      _: function _(t) {
        return {
          content: t[3],
          lang: t[2] || void 0,
          type: "codeBlock"
        };
      }
    },
    codeInline: {
      i: ht(m),
      l: Ot.LOW,
      _: function _(t) {
        return {
          content: t[2]
        };
      },
      p: function p(t, e, n) {
        return V("code", {
          key: n.g
        }, t.content);
      }
    },
    footnote: {
      i: kt(k),
      l: Ot.MAX,
      _: function _(t) {
        return rt.push({
          footnote: t[2],
          identifier: t[1]
        }), {};
      },
      p: Rt
    },
    footnoteReference: {
      i: yt(x),
      l: Ot.HIGH,
      _: function _(t) {
        return {
          content: t[1],
          target: "#".concat(q.slugify(t[1]))
        };
      },
      p: function p(t, e, n) {
        return V("a", {
          key: n.g,
          href: bt(t.target)
        }, V("sup", {
          key: n.g
        }, t.content));
      }
    },
    gfmTask: {
      i: yt(b),
      l: Ot.HIGH,
      _: function _(t) {
        return {
          completed: "x" === t[1].toLowerCase()
        };
      },
      p: function p(t, e, n) {
        return V("input", {
          checked: t.completed,
          key: n.g,
          readOnly: !0,
          type: "checkbox"
        });
      }
    },
    heading: {
      i: kt(S),
      l: Ot.HIGH,
      _: function _(t, e, n) {
        return {
          content: $t(e, t[2], n),
          id: q.slugify(t[2]),
          level: t[1].length
        };
      },
      p: function p(t, e, n) {
        return t.tag = "h".concat(t.level), V(t.tag, {
          id: t.id,
          key: n.g
        }, e(t.content, n));
      }
    },
    headingSetext: {
      i: kt($),
      l: Ot.MAX,
      _: function _(t, e, n) {
        return {
          content: $t(e, t[1], n),
          level: "=" === t[2] ? 1 : 2,
          type: "heading"
        };
      }
    },
    htmlComment: {
      i: xt(E),
      l: Ot.HIGH,
      _: function _() {
        return {};
      },
      p: Rt
    },
    image: {
      i: ht(lt),
      l: Ot.HIGH,
      _: function _(t) {
        return {
          alt: t[1],
          target: St(t[2]),
          title: t[3]
        };
      },
      p: function p(t, e, n) {
        return V("img", {
          key: n.g,
          alt: t.alt || void 0,
          title: t.title || void 0,
          src: bt(t.target)
        });
      }
    },
    link: {
      i: yt(it),
      l: Ot.LOW,
      _: function _(t, e, n) {
        return {
          content: wt(e, t[1], n),
          target: St(t[2]),
          title: t[3]
        };
      },
      p: function p(t, e, n) {
        return V("a", {
          key: n.g,
          href: bt(t.target),
          title: t.title
        }, e(t.content, n));
      }
    },
    linkAngleBraceStyleDetector: {
      i: yt(B),
      l: Ot.MAX,
      _: function _(t) {
        return {
          content: [{
            content: t[1],
            type: "text"
          }],
          target: t[1],
          type: "link"
        };
      }
    },
    linkBareUrlDetector: {
      i: function i(t, e) {
        return e.m ? null : yt(M)(t, e);
      },
      l: Ot.MAX,
      _: function _(t) {
        return {
          content: [{
            content: t[1],
            type: "text"
          }],
          target: t[1],
          title: void 0,
          type: "link"
        };
      }
    },
    linkMailtoDetector: {
      i: yt(O),
      l: Ot.MAX,
      _: function _(t) {
        var e = t[1],
            n = t[1];
        return i.test(n) || (n = "mailto:" + n), {
          content: [{
            content: e.replace("mailto:", ""),
            type: "text"
          }],
          target: n,
          type: "link"
        };
      }
    },
    list: {
      i: function i(t, e, n) {
        var r = T.exec(n);
        return !r || !e.h && e.o ? null : at.exec(t = r[1] + t);
      },
      l: Ot.HIGH,
      _: function _(t, e, n) {
        var r = t[2],
            o = r.length > 1,
            c = o ? +r : void 0,
            a = t[0].replace(l, "\n").match(ct);
        var u = !1;
        return {
          items: a.map(function (t, r) {
            var o = ot.exec(t)[0].length,
                c = new RegExp("^ {1," + o + "}", "gm"),
                i = t.replace(c, "").replace(ot, ""),
                l = r === a.length - 1,
                s = -1 !== i.indexOf("\n\n") || l && u;
            u = s;
            var _ = n.o,
                f = n.h;
            var d;
            n.h = !0, s ? (n.o = !1, d = i.replace(L, "\n\n")) : (n.o = !0, d = i.replace(L, ""));
            var p = e(d, n);
            return n.o = _, n.h = f, p;
          }),
          ordered: o,
          start: c
        };
      },
      p: function p(t, e, n) {
        return V(t.ordered ? "ol" : "ul", {
          key: n.g,
          start: t.start
        }, t.items.map(function (t, r) {
          return V("li", {
            key: r
          }, e(t, n));
        }));
      }
    },
    newlineCoalescer: {
      i: kt(y),
      l: Ot.LOW,
      _: At,
      p: function p() {
        return "\n";
      }
    },
    paragraph: {
      i: vt,
      l: Ot.LOW,
      _: Et,
      p: function p(t, e, n) {
        return V("p", {
          key: n.g
        }, e(t.content, n));
      }
    },
    ref: {
      i: yt(D),
      l: Ot.MAX,
      _: function _(t) {
        return ut[t[1]] = {
          target: t[2],
          title: t[4]
        }, {};
      },
      p: Rt
    },
    refImage: {
      i: ht(N),
      l: Ot.MAX,
      _: function _(t) {
        return {
          alt: t[1] || void 0,
          ref: t[2]
        };
      },
      p: function p(t, e, n) {
        return V("img", {
          key: n.g,
          alt: t.alt,
          src: bt(ut[t.ref].target),
          title: ut[t.ref].title
        });
      }
    },
    refLink: {
      i: yt(Z),
      l: Ot.MAX,
      _: function _(t, e, n) {
        return {
          content: e(t[1], n),
          fallbackContent: e(t[0].replace(F, "\\$1"), n),
          ref: t[2]
        };
      },
      p: function p(t, e, n) {
        return ut[t.ref] ? V("a", {
          key: n.g,
          href: bt(ut[t.ref].target),
          title: ut[t.ref].title
        }, e(t.content, n)) : V("span", {
          key: n.g
        }, e(t.fallbackContent, n));
      }
    },
    table: {
      i: kt(C),
      l: Ot.HIGH,
      _: gt,
      p: function p(t, e, n) {
        return V("table", {
          key: n.g
        }, V("thead", null, V("tr", null, t.header.map(function (r, o) {
          return V("th", {
            key: o,
            style: mt(t, o)
          }, e(r, n));
        }))), V("tbody", null, t.cells.map(function (r, o) {
          return V("tr", {
            key: o
          }, r.map(function (r, o) {
            return V("td", {
              key: o,
              style: mt(t, o)
            }, e(r, n));
          }));
        })));
      }
    },
    tableSeparator: {
      i: function i(t, e) {
        return e.t ? H.exec(t) : null;
      },
      l: Ot.HIGH,
      _: function _() {
        return {
          type: "tableSeparator"
        };
      },
      p: function p() {
        return " | ";
      }
    },
    text: {
      i: xt(tt),
      l: Ot.MIN,
      _: function _(t) {
        return {
          content: t[0].replace(z, function (t, e) {
            return q.namedCodesToUnicode[e] ? q.namedCodesToUnicode[e] : t;
          })
        };
      },
      p: function p(t) {
        return t.content;
      }
    },
    textBolded: {
      i: ht(X),
      l: Ot.MED,
      _: function _(t, e, n) {
        return {
          content: e(t[2], n)
        };
      },
      p: function p(t, e, n) {
        return V("strong", {
          key: n.g
        }, e(t.content, n));
      }
    },
    textEmphasized: {
      i: ht(J),
      l: Ot.LOW,
      _: function _(t, e, n) {
        return {
          content: e(t[2], n)
        };
      },
      p: function p(t, e, n) {
        return V("em", {
          key: n.g
        }, e(t.content, n));
      }
    },
    textEscaped: {
      i: ht(Y),
      l: Ot.HIGH,
      _: function _(t) {
        return {
          content: t[1],
          type: "text"
        };
      }
    },
    textStrikethroughed: {
      i: ht(K),
      l: Ot.LOW,
      _: Et,
      p: function p(t, e, n) {
        return V("del", {
          key: n.g
        }, e(t.content, n));
      }
    }
  };
  !0 !== q.disableParsingRawHTML && (st.htmlBlock = {
    i: xt(w),
    l: Ot.HIGH,
    _: function _(t, e, n) {
      var _t$3$match = t[3].match(nt),
          _t$3$match2 = _slicedToArray(_t$3$match, 2),
          r = _t$3$match2[1],
          o = new RegExp("^".concat(r), "gm"),
          c = t[3].replace(o, ""),
          u = (i = c, _t.some(function (t) {
        return t.test(i);
      }) ? zt : $t);

      var i;
      var l = t[1].toLowerCase(),
          s = -1 !== a.indexOf(l);
      n.m = n.m || "a" === l;

      var _ = s ? t[3] : u(e, c, n);

      return n.m = !1, {
        attrs: Q(t[2]),
        content: _,
        noInnerParse: s,
        tag: s ? l : t[1]
      };
    },
    p: function p(t, n, r) {
      return V(t.tag, e({
        key: r.g
      }, t.attrs), t.noInnerParse ? t.content : n(t.content, r));
    }
  }, st.htmlSelfClosing = {
    i: xt(R),
    l: Ot.HIGH,
    _: function _(t) {
      return {
        attrs: Q(t[2] || ""),
        tag: t[1]
      };
    },
    p: function p(t, n, r) {
      return V(t.tag, e({}, t.attrs, {
        key: r.g
      }));
    }
  });

  var dt = function (t) {
    var e = Object.keys(t);

    function n(r, o) {
      var c = [],
          a = "";

      for (; r;) {
        var _u2 = 0;

        for (; _u2 < e.length;) {
          var _i2 = e[_u2],
              _l2 = t[_i2],
              _s2 = _l2.i(r, o, a);

          if (_s2) {
            var _t2 = _s2[0];
            r = r.substring(_t2.length);

            var _e = _l2._(_s2, n, o);

            null == _e.type && (_e.type = _i2), c.push(_e), a = _t2;
            break;
          }

          _u2++;
        }
      }

      return c;
    }

    return e.sort(function (e, n) {
      var r = t[e].l,
          o = t[n].l;
      return r !== o ? r - o : e < n ? -1 : 1;
    }), function (t, e) {
      return n(function (t) {
        return t.replace(h, "\n").replace(v, "").replace(G, "    ");
      }(t), e);
    };
  }(st),
      pt = (Bt = function (t) {
    return function (e, n, r) {
      return t[e.type].p(e, n, r);
    };
  }(st), function t(e) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (Array.isArray(e)) {
      var _r = n.g,
          _o = [];

      var _c = !1;

      for (var _r2 = 0; _r2 < e.length; _r2++) {
        n.g = _r2;

        var _a = t(e[_r2], n),
            _u3 = "string" == typeof _a;

        _u3 && _c ? _o[_o.length - 1] += _a : null !== _a && _o.push(_a), _c = _u3;
      }

      return n.g = _r, _o;
    }

    return Bt(e, t, n);
  });

  var Bt;
  var Lt = W(r);
  return rt.length ? V("div", null, Lt, V("footer", {
    key: "footer"
  }, rt.map(function (t) {
    return V("div", {
      id: q.slugify(t.identifier),
      key: t.identifier
    }, t.identifier, pt(dt(t.footnote, {
      o: !0
    })));
  }))) : Lt;
}

!function (t) {
  t[t.MAX = 0] = "MAX", t[t.HIGH = 1] = "HIGH", t[t.MED = 2] = "MED", t[t.LOW = 3] = "LOW", t[t.MIN = 4] = "MIN";
}(Ot || (Ot = {}));
export default (function (e) {
  var n = e.children,
      o = e.options,
      c = function (t, e) {
    if (null == t) return {};
    var n,
        r,
        o = {},
        c = Object.keys(t);

    for (r = 0; r < c.length; r++) {
      e.indexOf(n = c[r]) >= 0 || (o[n] = t[n]);
    }

    return o;
  }(e, r);

  return t.cloneElement(Bt(n, o), c);
});
export { Bt as compiler };